import React, { useEffect, useState } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { FcPhoneAndroid, FcInfo, FcIdea } from "react-icons/fc";
import { GrMail } from "react-icons/gr";
import { MdDoNotDisturbAlt } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { Baseurl } from "../../../config/BaseUrl";
import axios from "axios";
import { Link } from "react-router-dom";
import moment from "moment/moment";
import { authActions } from "../../../redux/athentication/Athentication";
import { propertyUpdate } from "../../../redux/property/PropertySlice";
import { toast } from "react-toastify";
import DashboardPropertyCard from "./DashboardPropertyCard";
import "./DashboardListingsNew.css";

const Deleted = () => {
  const { propertyAllById } = useSelector((store) => store.Property);
  const { loginData } = useSelector((store) => store.Athentication);
  const dispatch = useDispatch();

  const [showProperty, setshowProperty] = useState([]);

  useEffect(() => {
    let sourceList = Array.isArray(propertyAllById) ? [...propertyAllById] : [];
    let deletedProps = sourceList.filter((p) => p.propertyStatus === "Deleted");
    setshowProperty(deletedProps);

    // If real user and nothing in Redux, try fetch
    const userId = loginData?._id;
    if (deletedProps.length === 0 && userId && !String(userId).startsWith("demo")) {
      const fetchdata = async () => {
        try {
          const url = `${Baseurl}/api/v1/property/deleted/${userId}`;
          const fetchProperty = await axios(url);
          if (fetchProperty.data?.success && Array.isArray(fetchProperty.data.property)) {
            setshowProperty(fetchProperty.data.property);
          }
        } catch (error) {}
      };
      fetchdata();
    }
  }, [propertyAllById, loginData?._id]);

  const recallClick = async (e, propertyId) => {
    const formdata = {
      mobile: loginData.mobile,
      creadittospent: 5,
    };
    const url = `${Baseurl}/api/v1/user/shopUserByMobile`;
    let fetchData = await axios.put(url, formdata);
    try {
      const authenticForm = {
        ...fetchData.data.user,
        isAuth: true,
      };
      dispatch(authActions.signIn(authenticForm));
    } catch (error) {}
    if (fetchData.data.success) {
      const propertyformdata = {
        propertyId: propertyId,
        propertyStatus: "Active",
      };
      dispatch(propertyUpdate(propertyformdata));

      const updateProperty = showProperty.filter(
        (data) => data._id !== propertyId
      );
      setshowProperty(updateProperty);
      toast.success("Property Recall Successfully", {
        position: "top-center",
        autoClose: 1500,
      });
    } else {
      toast.error("Please Recharge on Wallet", {
        position: "top-center",
        autoClose: 1000,
      });
    }
  };
  return (
    <div className="mgh-dl-container">
      {/* ================= Header Status Bar ================= */}
      <div className="mgh-dl-info-bar">
        <h4 className="mgh-dl-count-heading">
          <span>Deleted Listings</span>
          <span className="mgh-dl-count-pill">
            {showProperty.length}{" "}
            {showProperty.length === 1 ? "Property" : "Properties"}
          </span>
        </h4>

        <div className="mgh-dl-filters-row">
          <span className="mgh-dl-filter-tag">
            <span>Showing: Deleted</span>
          </span>
        </div>
      </div>

      {showProperty.length > 0 ? (
        showProperty.map((property, index) => (
          <DashboardPropertyCard
            key={property._id || index}
            property={property}
            packageType={loginData?.packageType || "DELETED LISTING"}
            onRecall={(prop) => recallClick(null, prop._id)}
          />
        ))
      ) : (
        <div className="mgh-dl-empty-state">
          <div className="mgh-dl-empty-icon">🗑️</div>
          <h3 className="mgh-dl-empty-title">No Deleted Properties</h3>
          <p className="mgh-dl-empty-desc">
            You don't have any deleted properties in trash.
          </p>
        </div>
      )}
    </div>
  );
};

export default Deleted;
